/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Local` - Keep it close to home
 * * `Regional` - Not opposed to some travel
 * * `National` - Willing to travel anywhere
 */
export enum TravelTypeEnum {
    LOCAL = 'Local',
    REGIONAL = 'Regional',
    NATIONAL = 'National',
}
